import { connect, FormikValues } from 'formik'
import { get } from 'lodash'
import { useEffect } from 'react'
import { IntlShape, useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import { object } from 'yup'

import CodeEditor from '@/pages/SpaceAppBuilder/components/CodeEditor/CodeEditor'

import messages from './messages'

type FeatureTriggerProps = {
  readonly?: boolean
}

const getValidationSchema = (intl: IntlShape) => {
  return {
    payload: object()
      .typeError(({ originalValue }) => {
        try {
          JSON.parse(originalValue)
        } catch {
          return intl.formatMessage(messages.payloadInvalidJson)
        }
        return true
      })
      .required(intl.formatMessage(messages.pleaseDefinePayload))
  }
}

const getInitialValues = (triggerData: any) => {
  return {
    payload: get(triggerData, 'payload', {})
  }
}

const FeatureTrigger = ({ formik, readOnly = false }: FeatureTriggerProps & FormikValues) => {
  const intl = useIntl()

  const { featureId } = useParams<{ spaceId: string; appId: string; featureId: string }>()
  const { values, setFieldValue, errors, setFieldError } = formik

  useEffect(() => {}, [featureId])

  return (
    <CodeEditor
      label={intl.formatMessage(messages.definePayload)}
      readOnly={readOnly}
      setFieldValue={setFieldValue}
      setFieldError={setFieldError}
      defaultValue={
        typeof values?.triggerData?.payload === 'string'
          ? values.triggerData.payload
          : JSON.stringify(values.triggerData.payload)
      }
      errors={errors}
    />
  )
}

export default connect(FeatureTrigger)

export { getInitialValues, getValidationSchema }
